import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NewActionTaxonomyActionComponent } from '../new-action-taxonomy-action/new-action-taxonomy-action.component';
import { NewActionTaxonomyStrategyComponent } from '../new-action-taxonomy-strategy/new-action-taxonomy-strategy.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-new-action-taxonomy-goals',
  templateUrl: './new-action-taxonomy-goals.component.html',
  styleUrls: ['./new-action-taxonomy-goals.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, NewActionTaxonomyActionComponent, NewActionTaxonomyStrategyComponent, DynamicContentComponent ]
})
export class NewActionTaxonomyGoalsComponent implements OnInit {


  @Input() goal: any;
  @Input() color: any;
  @Input() isParentOpen: boolean = false;
  @Input()
  public config: any;
  panelOpenState: boolean;

  constructor() { }

  get includeTier() {
    return this.goal.includeTier;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.isParentOpen) {
      if(changes.isParentOpen.previousValue == true && changes.isParentOpen.currentValue == false){
        this.handleClosed();
      }
    }
  }

  ngOnInit(): void {
  }

  handleOpened() {
    this.panelOpenState = true;
  }

  handleClosed() {
    this.panelOpenState = false;
  }


}
